<app-stages [stages]="stages" currentStage="Lokalizacja"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <br>
    <fieldset>
      <app-exposed-map-control #mapControl [control]="form.geometry">
      </app-exposed-map-control>
      <app-road-controls-set [expMapDict]="mapControl.dictEvent()" [form]="form"></app-road-controls-set>
    </fieldset>
    <fieldset>
      <legend>
        Działki, których dotyczy wniosek
      </legend>
      <app-parcels-crud [expMapDict]="mapControl.dictEvent()" tag="parcels" formControlName="parcels">
      </app-parcels-crud>
    </fieldset>
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
